import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  TEN_DIGIT_PHONE_NUMBER_REGEX,
  NUMBER_REGEX,
  US_TAX_ID_REGEX,
  NINE_DIGIT_NUMBER_REGEX,
  FIVE_NUMBER_REGEX,
} from "../../../utils/constants/ValidationRegexs";
import {
  authHeader,
  authfileHeader,
} from "../../../utils/functions/CoreFunctions";
import {
  AGENCY_CREATE_URL,
  AGENCY_UPDATE_URL,
  FILE_UPLOAD_URL,
} from "../../../utils/APIEndpoints";
import API from "../../../redux/actions/API";
import Swal from "sweetalert2";
import {
  getAlertToast,
  getCurrentUserId,
  SingleStringFirstLetterCaps,
  formatIntoHyphenedTaxid,
  getAlert,
} from "../../../utils/functions/CustomFunctions";
import CustomLoader from "../../common/CustomLoader";
import defaultAvatar from "../../../assets/images/defaultImages/defaultAvatar.png";
import LOCATION_CODE_CRUD from "./location_code/locationCodeCrud";
import shortid from "shortid";

const validationSchema = Yup.object({
  accountHolderName: Yup.string()
    .trim()
    .required("Account holder name is required"),
  accountNumber: Yup.string()
    .trim()
    .required("Account number is required")
    .matches(NUMBER_REGEX, "Enter valid account number"),
  companyName: Yup.string().trim().required("Agency name is required"),
  taxId: Yup.string()
    .trim()
    .required("Tax id is required")
    .matches(US_TAX_ID_REGEX, "Enter valid tax id. (ex : XX-XXXXXXX)"),
  ifscCode: Yup.string()
    .trim()
    .required("Routing number is required")
    .matches(NINE_DIGIT_NUMBER_REGEX, "Enter valid nine digits routing number"),
  // bankAddress: Yup.string().trim().required('Bank address is required'),
  agencyAddress: Yup.string().trim().required("Agency address is required"),
  agencyEmail: Yup.string()
    .trim()
    .required("Agency email is required")
    .email("Enter valid email"),
  agencyPhone: Yup.string()
    .trim()
    .required("Agency phone number is required")
    .matches(TEN_DIGIT_PHONE_NUMBER_REGEX, "Enter valid phone number"),
});

const Create = (props) => {
  const { toggle, modal, data, isAdd, saveCallBack, locationCodeFromResponse } =
    props;

  const { verificationDocument, agencyLogo } = data;
  const [logo, setLogo] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState();
  const [btnLoading, setButtonLoading] = useState();
  const [locationCodeData, setLocationCodeData] = useState(null);

  //save location code data
  const saveLocationCodeData = (value) => {
    Swal.fire(getAlert("success", "Location Code is added"));
    setLocationCodeData(value);
  };

  const handleUpload = async (type, event) => {
    event.preventDefault();
    const formData = new FormData();
    const fileValue = event.target.value;
    if (fileValue != "") {
      formData.append("file", event.target.files[0]);
      setLoading(true);
      const options = {
        method: "POST",
        url: FILE_UPLOAD_URL,
        headers: authfileHeader(),
        data: formData,
      };
      try {
        Swal.fire(getAlertToast("success", "Please wait..."));
        const response = await API(options);
        const { status, filepath } = response.data;
        if (status === "Success") {
          type === "logo" ? setLogo(filepath) : setImage(filepath);
          Swal.fire(getAlertToast("success", "File uploaded successfully"));
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          Swal.fire(getAlertToast("error", data.message));
        }
      } finally {
        setLoading(false);
      }
    }
  };

  //Formik
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    setFieldTouched,
    handleBlur,
    setFieldValue,
  } = useFormik({
    initialValues: {
      ...data,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });
  const autoApprovalhandle = (e) => {
    setFieldValue("autoApproval", e.target.checked);
  };

  //On Submit
  const saveFormValues = async (formValues) => {
    if (!locationCodeData) {
      Swal.fire(getAlertToast("error", "Please save location code"));
    } else {
      let dataToStore = {
        ...formValues,
        createdBy: getCurrentUserId(),
        verificationDocument: image,
        agencyLogo: logo,
        taxId: formValues.taxId.replace(/-/g, ""),
        locationCodeDetails: locationCodeData,
      };
      // if (!image) {
      //   Swal.fire(getAlertToast('error', 'Please upload verification document'));
      // } else if (!logo) {
      //   Swal.fire(getAlertToast('error', 'Please upload Agency Logo'));
      // } else {

      const options = {
        method: isAdd ? "POST" : "PUT",
        url: isAdd ? AGENCY_CREATE_URL : AGENCY_UPDATE_URL,
        headers: authHeader(),
        data: dataToStore,
      };
      try {
        setButtonLoading(true);
        let response = await API(options);
        const { status, message } = response.data;
        if (status === "Error") {
          Swal.fire(getAlertToast("error", message));
        } else {
          if (isAdd)
            Swal.fire(
              getAlert(
                "success",
                "Agency created successfully. Now create users for that agency to login"
              )
            );
          else
            Swal.fire(
              getAlertToast("success", "Agency details updated successfully")
            );
          saveCallBack();
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          Swal.fire(getAlertToast("error", data.message));
        }
      } finally {
        setButtonLoading(false);
      }
    }
  };

  useEffect(() => {
    setImage(verificationDocument);
    setLogo(agencyLogo);
  }, [verificationDocument, agencyLogo]);

  useEffect(() => {
    if (locationCodeFromResponse && locationCodeFromResponse.length) {
      const location_code_array = [];
      locationCodeFromResponse.forEach(({ description, locationCode }) => {
        location_code_array.push({
          locationCode,
          description,
        });
      });
      setLocationCodeData([...location_code_array]);
    }
  }, [locationCodeFromResponse]);

  // console.log('Image 1 ', image, 'verfication Document ', verificationDocument);

  return (
    <div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        className="viewAgency"
        style={{ maxWidth: "800px" }}
        backdrop="static"
      >
        <Form form="true" onSubmit={handleSubmit}>
          <ModalHeader toggle={toggle}>
            {isAdd ? "Create Agency" : "Update Agency"}
          </ModalHeader>
          <ModalBody>
            <div style={{ marginBottom: "2.5rem", fontWeight: "700" }}>
              <div className="imgUpload">
                <img
                  className="uploadImg"
                  src={logo || defaultAvatar}
                  widht={100}
                  height={100}
                />
                <label
                  style={{ marginBottom: "0" }}
                  className="btn-bs-file btn btn-lg btn-danger"
                >
                  <i className="fas fa-camera"></i>
                  <Input
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(event) => {
                      handleUpload("logo", event);
                    }}
                  />
                </label>
              </div>
              <center>
                <Label>Agency Logo</Label>
              </center>
            </div>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Agency Name *</Label>
                  <Input
                    type="text"
                    name="companyName"
                    placeholder="Enter Agency Name"
                    invalid={
                      errors.companyName && touched.companyName ? true : false
                    }
                    onChange={({ target: { value } }) => {
                      setFieldTouched("companyName", true);
                      setFieldValue(
                        "companyName",
                        SingleStringFirstLetterCaps(value)
                      );
                    }}
                    value={values.companyName}
                  />
                  <FormFeedback>
                    {errors.companyName && touched.companyName
                      ? errors.companyName
                      : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Agency Email *</Label>
                  <Input
                    type="email"
                    name="agencyEmail"
                    placeholder="Enter Agency Email"
                    invalid={
                      errors.agencyEmail && touched.agencyEmail ? true : false
                    }
                    onChange={(event) => {
                      setFieldTouched("agencyEmail", true);
                      handleChange(event);
                    }}
                    value={values.agencyEmail}
                  />
                  <FormFeedback>
                    {errors.agencyEmail ? errors.agencyEmail : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Agency Phone Number *</Label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>+1</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="text"
                      name="agencyPhone"
                      placeholder="Enter Agency Phone Number"
                      invalid={
                        errors.agencyPhone && touched.agencyPhone ? true : false
                      }
                      onChange={(event) => {
                        setFieldTouched("agencyPhone", true);
                        handleChange(event);
                      }}
                      value={values.agencyPhone}
                    />
                    <FormFeedback>
                      {errors.agencyPhone && touched.agencyPhone
                        ? errors.agencyPhone
                        : ""}
                    </FormFeedback>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Agency Address *</Label>
                  <Input
                    type="textarea"
                    name="agencyAddress"
                    placeholder="Agency Address"
                    invalid={
                      errors.agencyAddress && touched.agencyAddress
                        ? true
                        : false
                    }
                    onChange={({ target: { value } }) => {
                      setFieldTouched("agencyAddress", true);
                      setFieldValue(
                        "agencyAddress",
                        SingleStringFirstLetterCaps(value)
                      );
                    }}
                    value={values.agencyAddress}
                  />
                  <FormFeedback>
                    {errors.agencyAddress && touched.agencyAddress
                      ? errors.agencyAddress
                      : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Account Holder Name *</Label>
                  <Input
                    type="text"
                    name="accountHolderName"
                    placeholder="Enter Account Holder Name"
                    invalid={
                      errors.accountHolderName && touched.accountHolderName
                        ? true
                        : false
                    }
                    onChange={({ target: { value } }) => {
                      setFieldTouched("accountHolderName", true);
                      setFieldValue(
                        "accountHolderName",
                        SingleStringFirstLetterCaps(value)
                      );
                    }}
                    onBlur={handleBlur}
                    value={values.accountHolderName}
                  />
                  <FormFeedback>
                    {errors.accountHolderName && touched.accountHolderName
                      ? errors.accountHolderName
                      : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Account Number *</Label>
                  <Input
                    type="text"
                    name="accountNumber"
                    placeholder="Enter Account Number"
                    invalid={
                      errors.accountNumber && touched.accountNumber
                        ? true
                        : false
                    }
                    onChange={(event) => {
                      setFieldTouched("accountNumber", true);
                      handleChange(event);
                    }}
                    value={values.accountNumber}
                  />
                  <FormFeedback>
                    {errors.accountNumber && touched.accountNumber
                      ? errors.accountNumber
                      : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Routing Number *</Label>
                  <Input
                    type="text"
                    name="ifscCode"
                    placeholder="Enter Routing Number"
                    invalid={errors.ifscCode && touched.ifscCode ? true : false}
                    onChange={(event) => {
                      setFieldTouched("ifscCode", true);
                      handleChange(event);
                    }}
                    value={values.ifscCode}
                  />
                  <FormFeedback>
                    {errors.ifscCode && touched.ifscCode ? errors.ifscCode : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>
              {/* <Col md={6}> */}
              {/* <FormGroup>
                  <Label>Location Code ID *</Label>
                  <Input
                    type="text"
                    name="locationCodeId"
                    placeholder="Location Code ID"
                    invalid={
                      errors.locationCodeId && touched.locationCodeId
                        ? true
                        : false
                    }
                    onChange={(event) => {
                      setFieldTouched("locationCodeId", true);
                      handleChange(event);
                    }}
                    value={values.locationCodeId}
                  />
                  <FormFeedback>
                    {errors.locationCodeId && touched.locationCodeId
                      ? errors.locationCodeId
                      : ""}
                  </FormFeedback>
                </FormGroup> */}
              {/* </Col> */}
              <Col md={6}>
                <FormGroup>
                  <Label>Bank Address</Label>
                  <Input
                    type="textarea"
                    name="bankAddress"
                    placeholder="Bank Address"
                    // invalid={
                    //   errors.bankAddress && touched.bankAddress ? true : false
                    // }
                    // onChange={({ target: { value } }) => {
                    //   setFieldTouched('bankAddress', true);
                    //   setFieldValue(
                    //     'bankAddress',
                    //     SingleStringFirstLetterCaps(value)
                    //   );
                    // }}
                    onChange={handleChange}
                    value={values.bankAddress}
                  />
                  {/* <FormFeedback>
                    {errors.bankAddress && touched.bankAddress
                      ? errors.bankAddress
                      : ''}
                  </FormFeedback> */}
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Tax ID *</Label>
                  <Input
                    type="text"
                    name="taxId"
                    placeholder="Tax ID"
                    invalid={errors.taxId && touched.taxId ? true : false}
                    onChange={({ target: { value } }) => {
                      setFieldTouched("taxId", true);
                      setFieldValue("taxId", formatIntoHyphenedTaxid(value));
                    }}
                    value={values.taxId}
                  />
                  <FormFeedback>
                    {errors.taxId && touched.taxId ? errors.taxId : ""}
                  </FormFeedback>
                </FormGroup>
              </Col>

              <Col style={{ display: "flex", "align-items": "center" }} md={6}>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    onChange={autoApprovalhandle}
                    checked={values.autoApproval}
                    name="autoApproval"
                  />{" "}
                  <Label check>Auto Approval</Label>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label>Verification Document </Label>
                  <br />
                  <label
                    style={{ marginBottom: "0" }}
                    className="btn-bs-file btn btn-lg btn-info"
                  >
                    <i className="fas fa-file-upload"></i> Upload Document
                    <Input
                      type="file"
                      onChange={(event) => {
                        handleUpload("document", event);
                      }}
                    />
                  </label>
                  {loading && <CustomLoader loading={loading} />}
                  {image && (
                    <a href={image} target="_blank">
                      {" "}
                      <i
                        className="far fa-file"
                        style={{
                          marginLeft: "9px",
                          fontSize: "17px",
                          color: "#2689ef",
                        }}
                      ></i>
                    </a>
                  )}
                </FormGroup>
              </Col>
              <Col md={12}>
                <Label>Location Code(s)</Label>
                <LOCATION_CODE_CRUD
                  callback={saveLocationCodeData}
                  locationCodeFromResponse={locationCodeFromResponse}
                  isAdd={isAdd}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit">
              {btnLoading && <CustomLoader loading={btnLoading} />}{" "}
              {isAdd ? "Create" : "Update"}
            </Button>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default Create;
